// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"156":"88f417ee","310":"c5428f0a","506":"758617c5","634":"f84c73a4"}[chunkId] + ".chunk.js";
};